import { LoadingInput } from 'components/DecoratedInput.jsx';
import Button from 'components/Button.jsx';
import Select from 'components/Select.jsx';
import CardInput from 'payments/components/CardInput.jsx';
import CurrentUser from 'auth/CurrentUser';
import EncryptionNotice from 'components/EncryptionNotice.jsx';
import EventTrackingConstants from 'payments/constants/EventTrackingConstants';
import trackView from 'lib/trackView';
import Field from 'components/Field.jsx';
import FormMoneyInput from 'components/FormMoneyInput.jsx';
import linkStateWithStores from 'components/mixins/linkStateWithStores';
import List from 'components/List.jsx';
import ListItem from 'components/ListItem.jsx';
import Activity from 'entities/Activity';
import PaymentSourceActions from 'payments/actions/PaymentSourceActions';
import PaymentSourceStore from 'payments/stores/PaymentSourceStore';
import React from 'react';
import SettingsStore from 'stores/SettingsStore';
import StripeAPI from 'lib/StripeAPI';
import ToastActions from 'actions/ToastActions';
import connectEventScreenName from 'payments/utils/connectPaymentHeaderEventScreenName';

import './styles/PaymentCardCreator.scss';

let savedState = null;

const PaymentCardCreator = React.createClass({
  propTypes: {
    onContinue: React.PropTypes.func.isRequired,
    request: React.PropTypes.instanceOf(Activity).isRequired,
    errors: React.PropTypes.array,
  },

  childContextTypes: {
    eventScreenName: React.PropTypes.string,
  },

  mixins: [
    linkStateWithStores([PaymentSourceStore]),
  ],

  getInitialState() {
    const errorsContains = field => {
      return !!this.props.errors.some(
        error => error.code === field
      );
    };

    // if there's errors than we need to show
    // the previous state of this component
    if (this.props.errors && savedState && savedState.card) {
      // those are stripe errors https://stripe.com/docs/testing
      savedState.card.cvc.isValid = !errorsContains('incorrect_cvc');
      savedState.card.expiry.isValid = !errorsContains('expired_card');
      return savedState;
    }

    return Object.assign(this.getStateFromStores(), {
      amountPerPerson: this.props.request.getAmountPerPerson(),
      card: null,
    });
  },

  getChildContext() {
    return {
      eventScreenName: EventTrackingConstants.SELECT_PAYMENT,
    };
  },

  componentDidMount() {
    StripeAPI.setPublishableKey(SettingsStore.getStripeKey())
      .then(this.handleScriptLoaded, this.handleScriptError);
  },

  componentWillUnmount() {
    CurrentUser.removeSignInListener(this.onUserSignIn);
  },

  getStateFromStores() {
    return {
      paymentSourceIndex: 0,
      paymentSources: PaymentSourceStore.getPaymentSources(),
    };
  },

  onUserSignIn() {
    this.loadPaymentSources();
  },

  isUsingSaved() {
    return this.state.paymentSources &&
      this.state.paymentSources.size() > this.state.paymentSourceIndex;
  },

  onSubmit() {
    savedState = this.state;

    // if we have a payment source selected than use it!
    if (this.isUsingSaved()) {
      this.props.onContinue(
        this.state.amountPerPerson,
        this.state.paymentSources.at(this.state.paymentSourceIndex).id,
      );

      return;
    }

    // otherwise create a new card!
    const handleStripeResponse = (status, response) => {
      if (response.error) {
        ToastActions.showErrorToast(response.error.message);
      } else {
        this.props.onContinue(
          this.state.amountPerPerson,
          response.id,
        );
      }
    };

    StripeAPI.createCardToken({
      number: this.state.card.number.value,
      cvc: this.state.card.cvc.value,
      exp: this.state.card.expiry.value,
      address_zip: this.state.card.zip.value,
    }, handleStripeResponse.bind(this));
  },

  handleScriptError() {
    ToastActions.showErrorToast(
      'Looks like there was an error loading the page. Please reload to continue.'
    );
  },

  handleScriptLoaded() {
    CurrentUser.addSignInListener(this.onUserSignIn);

    if (CurrentUser.isSignedIn() && PaymentSourceStore.getPaymentSources().length <= 0) {
      this.loadPaymentSources();
    }
  },

  loadPaymentSources() {
    const loaded = () => this.setState({ isLoadingPaymentSources: false });

    this.setState({ isLoadingPaymentSources: true }, () => {
      PaymentSourceActions.load().then(loaded, loaded);
    });
  },

  handleAmountChange({ value }) {
    this.setState({ amountPerPerson: value });
  },

  isSubmitEnabled() {
    return (
      (this.isUsingSaved() || this.state.card) &&
      this.state.amountPerPerson > 0
    );
  },

  paymentSourceOptions() {
    return (this.state.paymentSources || []).map((source, index) => {
      return {
        label: `${source.getBrand()} ending in ${source.getLastFourDigit()}`,
        value: `${index}`,
      };
    }).concat({ label: 'Add a new card', value: `${this.state.paymentSources.size()}` });
  },

  renderCardInput() {
    const { paymentSources, paymentSourceIndex } = this.state;

    if (this.state.isLoadingPaymentSources) {
      return <LoadingInput />;
    }

    return (
      <div>
        {paymentSources && paymentSources.size() > 0 &&
          <Select
            options={this.paymentSourceOptions()}
            value={`${paymentSourceIndex}`}
            onChange={index => this.setState({ paymentSourceIndex: index })}
          />
        }

        {!this.isUsingSaved() &&
          <CardInput
            className="PaymentCardCreator-cardInput"
            values={this.state.card}
            onValid={card => this.setState({ card })}
            onInvalid={() => this.setState({ card: null })}
            eventScreenName={EventTrackingConstants.SELECT_PAYMENT}
          />
        }
      </div>
    );
  },

  renderErrors() {
    const errors = this.props.errors.map(error =>
      error.messages.map((message, index) =>
        <ListItem key={index}>{message}</ListItem>
      )
    );

    return (
      <div className="PaymentCardCreator-errorList">
        <div>An error occured during the payment process:</div>
        <List className="PaymentCardCreator-error">
          {errors}
        </List>
      </div>
    );
  },

  render() {
    return (
      <div className="PaymentCardCreator-content">
        <FormMoneyInput
          border={false}
          currency="USD"
          minimum={this.props.request.getFee()}
          initialCentValue={
            this.state.amountPerPerson ||
            this.props.request.getAmountPerPerson()
          }
          className="PaymentCardCreator-moneyInput"
          onValidChange={(amountPerPerson) => this.setState({ amountPerPerson })}
          onInvalidChange={() => this.setState({ amountPerPerson: null })}
        />

        <Field>
          {this.renderCardInput()}
        </Field>

        {
          this.props.errors &&
          this.props.errors.length > 0 &&
          this.renderErrors()
        }

        <Button
          onClick={this.onSubmit}
          data-test-selector="payment_card_creator_submit"
          className="PaymentCardCreator-cardEntryButton"
          disabled={!this.isSubmitEnabled()}
          eventScreenName={EventTrackingConstants.SELECT_PAYMENT}
          eventElementName="continue">
          Continue
        </Button>
        <EncryptionNotice />
      </div>
    );
  },
});

export default trackView(connectEventScreenName(PaymentCardCreator));



// WEBPACK FOOTER //
// ./src/payments/components/PaymentCardCreator.jsx